'use client';

import PropTypes from 'prop-types';
import SanityImage from '@sanity-image';
import { useState, useEffect, useRef } from 'react';
import styles from './hotspot-viewer.module.scss';
import CloseButton from 'assets/icons/close-x.svg';
const HotSpotViewer = (props) => {
	const image = props.image;
	const hotspots = props.hotspots;

	const [zoomStyles, setZoomStyles] = useState(null);
	const [activeHotspotIndex, setActiveHotspotIndex] = useState(null);
	const ref = useRef(null);

	const handleClick = (index) => {
		setActiveHotspotIndex(index);
	};

	const handlePreClick = (hotspot) => {
		if (activeHotspotIndex === null) {
			setZoomStyles({
				transformOrigin: `${hotspot.x}% ${hotspot.y}%`,
			});
		}
	};

	const handleClose = () => {
		setActiveHotspotIndex(null);
		setZoomStyles(null);
	};

	const handleImageClick = (e) => {
		e.preventDefault();
		if (activeHotspotIndex !== null && e.target.tagName === 'IMG') {
			handleClose();
		}
	};

	const handleKeyDown = (e) => {
		e = e || window.event;
		if (e.keyCode == '37') {
			!(activeHotspotIndex === 0)
				? setActiveHotspotIndex(activeHotspotIndex - 1)
				: setActiveHotspotIndex(hotspots.length - 1);
		} else if (e.keyCode == '39') {
			!(activeHotspotIndex === hotspots.length - 1)
				? setActiveHotspotIndex(activeHotspotIndex + 1)
				: setActiveHotspotIndex(0);
		} else if (e.key == 'Escape') {
			handleClose();
		}
	};

	/* eslint-disable react-hooks/set-state-in-effect -- TODO: Let's refactor this to avoid setting state in useEffect. */
	useEffect(() => {
		if (activeHotspotIndex === null) {
			return;
		}

		const hotspot = hotspots[activeHotspotIndex];
		ref.current.scrollIntoView({ behavior: 'smooth' });
		setZoomStyles({
			transform: 'scale(2)',
			transformOrigin: `${hotspot.x}% ${hotspot.y}%`,
		});
	}, [activeHotspotIndex, hotspots]);
	/* eslint-enable react-hooks/set-state-in-effect */

	return (
		<section
			ref={ref}
			onKeyDown={handleKeyDown}
			tabIndex={'-1'}
			className={styles.hotspotSection}
		>
			<div className={styles.hotspotViewer}>
				{activeHotspotIndex !== null && (
					<div className={styles.hotSpotInfo}>
						<div className={styles.hotSpotTitle}>
							<h3>{hotspots[activeHotspotIndex].title}</h3>
							<button onClick={handleClose} className={styles.closeButton}>
								<CloseButton />
							</button>
						</div>
						<div>{hotspots[activeHotspotIndex].details}</div>
					</div>
				)}
				<div
					className={styles.wrapper}
					data-zoomed={activeHotspotIndex !== null}
				>
					<div
						style={zoomStyles}
						onClick={handleImageClick}
						className={styles.imageWrapper}
					>
						<SanityImage
							className={styles.image}
							sizes={'(max-width: 960px) 160vw, 1000px'}
							priority={true}
							image={image}
						/>
						{hotspots?.map((hotspot, i) => {
							return (
								<button
									onFocus={() => handlePreClick(hotspot)}
									onMouseEnter={() => handlePreClick(hotspot)}
									onClick={() => handleClick(i)}
									key={`${hotspot.y}/${hotspot.x}`}
									className={styles.hotspot}
									data-details={hotspot.details}
									style={{ top: `${hotspot.y}%`, left: `${hotspot.x}%` }}
								/>
							);
						})}
					</div>
				</div>
			</div>
		</section>
	);
};

HotSpotViewer.propTypes = {
	hotspots: PropTypes.array,
	image: PropTypes.object,
};

export default HotSpotViewer;
